import { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { graphql } from '../gql';
import { CountriesQuery } from '../gql/graphql';
import { ArrayElement } from '@calefy-inc/utilityTypes';
import { isNotNullish } from '../util';

type Country = ArrayElement<NonNullable<CountriesQuery['countries']>>;
export const useCountries = () => {
  const [countries, setCountries] = useState<Array<Country>>([]);

  const [getCountries, { data }] = useLazyQuery(ALL_COUNTRIES);

  // get the countries on load
  useEffect(() => {
    getCountries();
  }, []);

  // set the data once we have it
  useEffect(() => {
    if (data?.countries) {
      setCountries(data.countries.filter(isNotNullish));
    }
  }, [data]);

  return countries;
};

const ALL_COUNTRIES = graphql(`
  query countries {
    countries {
      name
      alpha2
      alpha3
    }
  }
`);
